import React from "react";
import { Box, Skeleton } from "@mui/material";

const DetailsSkeleton = () => {
  return (
    <Box data-testid="show-skeleton">
      <Skeleton height={32} />
      <Box sx={{ mt: 4 }}>
        <Skeleton height={32} />
        <Skeleton height={32} width={"80%"} />
        <Skeleton height={32} width={"40%"} />
        <Skeleton height={32} width={"60%"} />
        <Skeleton height={32} width={"20%"} />
      </Box>
    </Box>
  );
};

export default DetailsSkeleton;
